import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { HubSpotCopySource } from 'app/model/pipeline/copysource/hub-spot.copysource';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(HubSpotCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*'
    }
})
export class HubSpotCopySourceAdapter extends CopySourceAdapter<HubSpotCopySource, Model.HubspotSource> {
    protected override async _toResource(copySource: HubSpotCopySource): Promise<Model.HubspotSource> {
        return this._toTabularResource(copySource, Metamodel.modelFor(HubSpotCopySource).name);
    }

    protected override async _toModel(
        resource: Model.HubspotSource,
        copyActivity: CopyActivity
    ): Promise<HubSpotCopySource> {
        return this._toTabularModel(resource, copyActivity, HubSpotCopySource.MODEL);
    }
}
